import React from 'react';
import WarningIcon from '@mui/icons-material/Warning';
import ScheduleIcon from '@mui/icons-material/Schedule';
import { Alert, AlertTitle, Typography, Button, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

/**
 * 이메일 인증 유예 기간 경고 컴포넌트
 */
const EmailVerificationGraceWarning = ({ 
  timeRemaining,
  showTimeRemaining = true,
  onResendVerification,
  isResending = false 
}) => {
  const { t } = useTranslation();
  
  // timeRemaining이 없고 showTimeRemaining이 true면 표시하지 않음
  if (showTimeRemaining && !timeRemaining) return null;

  return (
    <Alert 
      severity="warning"
      icon={<WarningIcon />}
      sx={{ 
        mb: 2,
        '& .MuiAlert-message': {
          width: '100%'
        },
        bgcolor: '#fff3cd',
        borderColor: '#ffeaa7',
        color: '#856404'
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
        <Box sx={{ flex: 1 }}>
          <Typography variant="body2" sx={{ fontWeight: 600, mb: showTimeRemaining ? 0.5 : 0 }}>
            {t('emailVerification.warning')}
          </Typography>
          {showTimeRemaining && timeRemaining && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <ScheduleIcon sx={{ fontSize: 16, color: '#856404' }} />
              <Typography variant="body2" sx={{ fontSize: '0.875rem' }}>
                {t('emailVerification.timeRemaining', { time: timeRemaining })}
              </Typography>
            </Box>
          )}
        </Box>
        
        <Button
          size="small"
          variant="outlined"
          onClick={onResendVerification}
          disabled={isResending}
          sx={{ 
            ml: 2,
            minWidth: 'auto',
            whiteSpace: 'nowrap',
            borderColor: '#856404',
            color: '#856404',
            '&:hover': {
              borderColor: '#6c5ce7',
              bgcolor: 'rgba(108, 92, 231, 0.04)'
            }
          }}
        >
          {isResending ? t('emailVerification.resending') : t('emailVerification.resendButton')}
        </Button>
      </Box>
    </Alert>
  );
};

export default EmailVerificationGraceWarning; 